<template>
    <div oc-callback-form>
        <div class="blacking" @click="hideSelf"></div>
        <div class="agreement-container">
            <div class="close" @click="hideSelf">X</div>
            <div class="agreement-text">
                <h3>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ И ПОЛУЧЕНИЕ РЕКЛАМЫ</h3>
                <br>
                Настоящим даю свое согласие на обработку ООО «Автомир-Трейд» (местонахождение: РФ, 107497, г. Москва, ул. Иркутская д. 5/6, стр.1, пом. 321), далее – Оператор, в том числе лицам, указанным в Политике Оператора в отношении обработки персональных данных (http://www.avtomir.ru/), а также другим лицам, которым Оператор имеет право поручить обработку персональных данных или по поручению которых Оператор осуществляет обработку персональных данных, моих персональных данных, указанных мною на сайте Оператора в сети Интернет, с использованием средств автоматизации, в т.ч. в информационно-телекоммуникационных сетях, исключительно в целях, указанных в Политике Оператора в отношении обработки персональных данных (http://www.avtomir.ru/).
                <br><br>
                Перечень персональных данных, на обработку которых дается согласие: пол, фамилия, имя, отчество, дата рождения, реквизиты документа, удостоверяющего личность (наименование, номер, серия, дата и орган, выдавший документ), адрес регистрации, номер контактного телефона, адрес электронной почты; модель приобретенного/обслуживаемого автомобиля, государственный номерной знак автомобиля, VIN, пробег автомобиля, история приобретения/обслуживания и ремонта автомобиля (в т.ч. дата и место приобретения/обслуживания автомобиля, перечень работ, замененных деталей), история страхования.
                <br><br>
                Перечень действий с персональными данными, на совершение которых дается согласие: сбор, запись (в т.ч. на магнитный/электронный носитель), систематизация, накопление, хранение (в электронном виде и/или на бумажном носителе), уточнение (обновление, изменение), извлечение, использование, передача (распространение, предоставление, доступ, трансграничная передача персональных данных), обезличивание, блокирование, удаление, уничтожение персональных данных.
                <br><br>
                Настоящее согласие дается при условии обеспечения Оператором соблюдения конфиденциальности персональных данных, а также обеспечения соблюдения уполномоченными им лицами и контрагентами конфиденциальности в отношении предоставленной информации.
                <br><br>
                Согласие на обработку персональных данных в соответствии с указанными выше условиями предоставляется мной бессрочно.
                <br><br>
                Настоящим подтверждаю, что мне предоставлена Оператором информация о правах, которые предоставлены мне Федеральным законом № 152-ФЗ от 27 июля 2006 года «О персональных данных», мне понятно, что настоящее согласие может быть отозвано (в случае моего несогласия с дальнейшей обработкой моих персональных данных) путем направления в письменной форме уведомления заказным почтовым отправлением с описью вложения, либо вручено лично под роспись уполномоченному представителю Оператора.
                <br><br>
                Настоящим подтверждаю, что давая согласие на обработку персональных данных, нахожусь на территории РФ, мне известно, что Оператор ведет деятельность на территории РФ в соответствии с законодательством РФ, предлагаемые Оператором товары, работы, услуги доступны к получению на территории РФ, Оператор не ведет мониторинг потребительского поведения субъектов, находящихся за пределами РФ.
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        components: {},
        directives: {},
        mixins: [],
        props: [''],
        data() {
            return {}
        },
        computed: {},
        methods: {
            hideSelf() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped lang="scss">
    .blacking {
        position: fixed;
        z-index: 500;
        top: -100vh;
        left: -100vw;
        bottom: -100vw;
        right: -100vh;
        background: #000;
        opacity: 0.5;
        cursor: default;
    }

    .agreement-container {
        top: 30px;
        height: calc(100vh - 90px);
        left: 15px;
        width: calc(100vw - 30px);
        position: fixed;
        z-index: 1200;
        background: #fff;
        padding: 40px 20px;
        cursor: default;
    }

    .close {
        position: absolute;
        font-size: 20px;
        top: 10px;
        right: 15px;
        cursor: pointer;
    }

    .agreement-text {
        font-size: 14px;
        overflow: auto;
        max-height: 100%;

        h3 {
            font-weight: 700;
            text-align: center;
        }
    }
</style>